<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/C6mrnu/tc-custom/9781786290373.jpg?1705766068821" alt="This image is the cover for the book Voyage to the Land of Blue Mists"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Voyage to the Land of Blue Mists
      </h1>
      <p class="bookDescription body article font2">
        <p>Nobody ever suspected that a secret lay hidden in the picture that Zivilia had inherited from her mother. That it had been painted in the land of Blue Mists, a strange hermit kingdom that lay on the other side of the world, had been long forgotten. Besides, Zivilia knew nothing of the country’s blood-splattered history, or the disruption caused by the League of Ausburg and their traders in the brief period when they were there many years ago. Thus learning her painting held clues as to where to find a lost relict came as a total surprise to her. People in the know seemed to think that it was buried somewhere in that mysterious island archipelago. There was astonishment that her religious order should decide to commission her to locate and then retrieve it. The task could have easily be given to another deemed to be more suitable. How then was she to travel there with her flying fox animal companion Fluffy? Had one of the Divines known that she would need one day to make the voyage there? The answer surely must be ‘Yes.’ Why else would she have made friends with the crew of the small trading ship ‘The Dark Sun’ years ago? Like many things the long journey to solve the mystery and recover the relict wasn’t that straight forward. But then life never is! Is it?</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Peter Bishop
      </h2>
      
      <p class="authorDescription body article">Peter Bishop moved to Dublin in Ireland from the UK in the early 1990s. He worked in the food industry before starting a new career in IT after being made redundant in the 2009 Recession. He inherited a love of reading from his parents. From childhood, he has had a passionate interest in History. This helped him immensely in the research of his family tree, a project lasting over 25 years. His wide and deep interests and knowledge of history, economics and technology are reflected in his writing. He has a basic fluency in French.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Austin Macauley Publishers
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?676c4148